module.exports = __webpack_public_path__ + "lemos.jpg?43054d714f6d14b83c7068a1d810bf74";